import { useState } from 'react'
import Button from 'src/components/buttons/button'
import Icon from 'src/components/icons/icon'
import BasicModal from 'src/components/modals/modal.basic'

type YoutubeProps = {
  video: string
  title?: string
  text?: string
  kind?: 'link' | 'embed'
  className?: string
  autoplay?: boolean
  loop?: boolean
}

export const Youtube = ({ video, title, text, className, autoplay = false, loop = false, kind = 'embed' }: YoutubeProps) => {
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <>
      {kind == 'embed' ? (
        <div
          className={`ring-outline relative aspect-video w-full overflow-hidden rounded-lg bg-white shadow-lg ring ring-1 ${className}`}
        >
          <iframe
            title='YouTube video player'
            src={`https://www.youtube.com/embed/${video}?rel=0${autoplay ? '&autoplay=1&mute=1' : ''}${loop ? `&loop=1&playlist=${video}` : ''}`}
            className='display-block absolute h-full w-full border-0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
          />
          <div>{autoplay}</div>
        </div>
      ) : (
        <>
          <a
            target='_blank'
            href={`https://www.youtube.com/watch?v=${video}`}
            className='group block'
            onClick={(e) => {
              setModalOpen(true)
              e.preventDefault()
            }}
            rel='noreferrer'
          >
            <div className='relative'>
              <img
                src={`https://img.youtube.com/vi/${video}/hqdefault.jpg`}
                className='aspect-video w-full rounded-lg object-cover transition group-hover:shadow-lg'
                alt={title}
              />
              <div className='bg-brand absolute inset-0 m-auto size-14 rounded-full transition group-hover:scale-125'>
                <Icon name='lucide-play' size={24} className='!absolute inset-0 m-auto block size-6 text-white' />
              </div>
            </div>
            {(title || text) && (
              <div className='pt-3'>
                <h5 className='h5'>{title}</h5>
                <p className='text-light line-clamp-2 text-sm'>{text}</p>
              </div>
            )}
          </a>
          <BasicModal
            title={title}
            isOpen={modalOpen}
            onClose={() => {
              setModalOpen(false)
            }}
            contentClasses='!p-0'
            buttons={
              <Button
                kind='secondary'
                onClick={() => {
                  setModalOpen(false)
                }}
              >
                Close
              </Button>
            }
          >
            <div className='relative aspect-video w-full overflow-hidden'>
              <iframe
                title='YouTube video player'
                src={`https://www.youtube.com/embed/${video}?rel=0&autoplay=1`}
                className='display-block absolute h-full w-full border-0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                referrerPolicy='strict-origin-when-cross-origin'
                allowFullScreen
              />
            </div>
          </BasicModal>
        </>
      )}
    </>
  )
}

export default Youtube
